var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "i8-modal",
    { attrs: { showClose: false, title: _vm.$route.params.code } },
    [
      _c("div", {
        directives: [
          {
            name: "t",
            rawName: "v-t",
            value: _vm.$t(_vm.langRoot + "." + _vm.$route.params.code),
            expression: "$t(`${langRoot}.${$route.params.code}`)"
          }
        ],
        attrs: { slot: "i8-modal-body" },
        slot: "i8-modal-body"
      }),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "i8-modal-footer" }, slot: "i8-modal-footer" },
        [
          _c("div", { staticClass: "level" }, [
            _c("div", { staticClass: "level-left" }, [_vm._v(" ")]),
            _vm._v(" "),
            _c("div", { staticClass: "level-right" }, [
              _c("div", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: _vm.$t(_vm.langRoot + ".backBtn"),
                    expression: "$t(`${langRoot}.backBtn`)"
                  }
                ],
                staticClass: "btn primary",
                on: {
                  click: function($event) {
                    return _vm.$router.replace("/")
                  }
                }
              })
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3255b42a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3255b42a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./shared/components/ErrorPage.vue
// module id = fBh/
// module chunks = 0 1